import { useDispatch } from 'react-redux';
import images from '../../assets/images';
import './MobileHeader.scss';
import { setIsSidebarOpen } from '../../redux/slices/authSlice';
import { FC } from 'react';

type propsType = {
    handleSearchClick?: () => void;
}

const MobileHeader:FC<propsType> = ({ handleSearchClick }) => {
    const { SearchBlack, menuIcon } = images;
    const dispatch = useDispatch();

    const toggleSidebar = (newOpen: boolean) => () => {
        dispatch(setIsSidebarOpen({ isSidebarOpen: newOpen }));
    };

    return (
        <div className='MobileHeaderContainer'>
            {handleSearchClick && <div className='SearchIconContainer' onClick={handleSearchClick}>
                <img src={SearchBlack} alt='searchIcon' className='searchIconMobile' />
            </div>}
            <div className='menuIconContainer' onClick={toggleSidebar(true)}>
                <img src={menuIcon} alt='menuIcon' className='menuIconMobile' />
            </div>
        </div>
    )
}

export default MobileHeader;
